import Vue from "vue";
import store from "./store/store";
import {
    Button,
    Container,
    Header,
    Icon,
    Dialog,
    Divider,
    Link,
    Input,
    Avatar,
    Popover,
    Main,
    Tooltip,
    Image,
    Footer,
    Progress,
    Message,
    MessageBox,
    Loading,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./plugins/api";
import App from "./App.vue";
import "@/assets/icons/iconfont.css";
import router from "./router";

Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Divider);
Vue.use(Link);
Vue.use(Input);
Vue.use(Avatar);
Vue.use(Popover);
Vue.use(Main);
Vue.use(Tooltip);
Vue.use(Image);
Vue.use(Footer);
Vue.use(Progress);
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
